import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { PageHeaderComponent } from '../../atoms/page-header/page-header.component';
import { InfoCardComponent } from '../../molecules/info-card/info-card.component';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';
import { IconComponent } from '@ui';

@Component({
  selector: 'ui-losses-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    PageHeaderComponent,
    InfoCardComponent,
    TranslocoDatePipe,
    IconComponent
  ],
  template: `
    <ng-container *transloco="let t">
      <ui-page-header [class]="'bg-yellow-50'">
        <div class="col-span-1 sm:col-span-12 xl:col-span-12">
          <ui-info-card
            [title]="t('LOSSES.LABEL')"
            icon="line-chart"
            [iconClasses]="'text-yellow-500'"
          >
          <p class="text-gray-500">
            {{ t('LOSSES.LAST_DATE') }}
            {{
              lastLossesdate()
                ? (lastLossesdate()| translocoDate: { dateStyle: 'short', timeStyle: 'short' })
                : '--'
            }}
            <ui-icon class="text-black" icon="reload"/>
          </p>
          </ui-info-card>
        </div>
      </ui-page-header>
    </ng-container>
  `,
})
export class LossesHeaderComponent {
  lastLossesdate = input<any>('');
}
